<template>
    <b-modal
        v-model="show"
        cancel-title="Abbrechen"
        modal-class="email-category-edit-modal info-card editMode"
        ok-title="Speichern"
        size="lg"
        title="Kategorien bearbeiten"
        @ok.prevent="save">
        <div v-if="isLoading" class="d-flex justify-content-center pt-4">
            <csp-loading-indicator/>
        </div>
        <div v-if="!isLoading" class="row">
            <p v-if="availableCategories.length === 0" class="text-muted">
                Keine Kategorien für diese Mailbox konfiguriert.
            </p>

            <b-form-group
                v-else
                class="info-card-element col-7 col-lg-9"
                label="Kategorien"
                label-for="category-select">
                <csp-form-select-searchable-with-tags
                    id="category-select"
                    :close-on-select="false"
                    :options="availableCategories"
                    placeholder="Kategorien auswählen …"
                    :values="selectedCategoryIds"
                    @change="onCategoryChange"/>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
    import Container from '@services/Container';
    import SelectSearchableWithTags from '@components/form/SelectSearchableWithTags.vue';

    const container = Container.getInstance();
    const digitalMailboxRepository = container.getDigitalMailboxRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'EmailCategoryEditModal',
        components: {
            'csp-form-select-searchable-with-tags': SelectSearchableWithTags,
        },
        props: {
            emailId: {
                default: null,
                type: String,
            },
            showModal: {
                default: false,
                type: Boolean,
            },
        },
        emits: ['categories-changed', 'update:showModal'],
        data() {
            return {
                availableCategories: [],
                isLoading: false,
                selectedCategoryIds: [],
            };
        },
        computed: {
            show: {
                get() {
                    return this.showModal;
                },
                set(value) {
                    this.$emit('update:showModal', value);
                },
            },
        },
        watch: {
            showModal(newVal) {
                if (newVal) {
                    this.loadData();
                }
            },
        },
        methods: {
            loadData() {
                this.isLoading = true;
                Promise.all([
                    digitalMailboxRepository.loadAvailableCategories(this.emailId),
                    digitalMailboxRepository.loadEmailCategories(this.emailId),
                ])
                    .then(([available, current]) => {
                        this.availableCategories = available;
                        this.selectedCategoryIds = current.map(option => option.value);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            onCategoryChange(values) {
                this.selectedCategoryIds = values;
            },
            save() {
                this.isLoading = true;
                digitalMailboxRepository.setEmailCategories(this.emailId, this.selectedCategoryIds)
                    .then(() => {
                        flashMessenger.addSuccess('Kategorien wurden gespeichert.');
                        this.$emit('categories-changed');
                        this.show = false;
                    })
                    .catch(() => {
                        flashMessenger.addError('Kategorien konnten nicht gespeichert werden.');
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
        },
    };
</script>
